import React from 'react';

const AuthContext = React.createContext();
const TicketContext = React.createContext();

export {
  AuthContext,
  TicketContext
};
